import { useUser } from "@accredo/fe-shared/hooks/user.js";
import policy from "../../policies/ClaimCommunicationPolicy.js";

export function useClaimCommunicationPermissions() {
  const { user } = useUser();
  return {
    canMessageInsurer: (claim) => policy.messageInsurer({ user, claim }),
    canDelete: (communication) => Boolean(communication?.can_delete),
    canForward: (communication) => policy.forward({ user, communication }),
    canRemind: (communication) => policy.remind({ user, communication }),
    canUpdateSubject: (communication) => policy.updateSubject({user, communication}),
  };
}
